import React, { useState, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import SearchIcon from '../../assests/icons/SearchIcon'
import Button from '../../Tool-kit/Button'
import Flex from '../../Tool-kit/Flex'
import { devices } from '../../Tool-kit/styles/mediaQueries'
import Text from '../../Tool-kit/Typography'
import useThemeContext from '../../hooks/useThemeContext'
// import { Input } from '../../Tool-kit/Input'
import QueryAccount from 'components/QueryAccount'
import Loader from 'components/Loader'
import mq from 'mediaQuery'
import * as qs from 'qs'
import { useLocale } from 'hooks/useLocale'
import { useFetchPage } from 'hooks/useFetchPage'
import { parseSearchTerm } from '../../utils/utils'
const { REACT_APP_STRAPI_API_URL } = process.env

const Wrapper = styled(Flex)`
  flex-direction: column;
  margin-bottom: 8rem;
  padding: 16px;

  .search-box {
    max-width: 1200px;
    margin: auto;
    width: 100%;

    @media ${devices.tabport} {
      width: 95%;
      gap: 1rem;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: center;
    }
    @media ${devices.phone} {
      button {
        width: 100%;
      }
    }
  }
`

const CallToAction = () => {
  const history = useHistory()
  const { isDark } = useThemeContext()
  const { locale } = useLocale()
  const query = qs.stringify({
    populate: '*',
    locale: [locale]
  })
  const fetcher = () =>
    fetch(`${REACT_APP_STRAPI_API_URL}/api/call-to-action?${query}`).then(res =>
      res.json()
    )
  const { data } = useFetchPage([`api/call-to-action`, locale], fetcher)

  const [inputVal, setInputVal] = useState('')
  const [isLoading, setISLoading] = useState(false)

  const onChange = useCallback(e => {
    setInputVal(e.target.value)
  }, [])

  const onSearch = useCallback(
    async account => {
      const hasSearch = inputVal && inputVal.length > 0

      if (!hasSearch) return
      if (account === '0') {
        toast.error('Please connect Metamask!')
        return
      }

      setISLoading(true)
      const type = await parseSearchTerm(inputVal)

      let searchTerm
      searchTerm = inputVal.toLowerCase()
      if (!searchTerm || searchTerm.length < 1) {
        return
      }

      if (type === 'address') {
        history.push(`/address/${searchTerm}`)
        return
      }

      if (type === 'supported' || type === 'short') {
        history.push(`/name/${searchTerm}`)
        return
      } else {
        history.push(`/search/${searchTerm}`)
      }
    },
    [history, inputVal]
  )

  return (
    <Wrapper>
      <Text
        font="h4Bold"
        color="textSecondary"
        mb="3.3rem"
        align="center"
        fontFamily="Roboto"
      >
        {data?.title}
      </Text>
      <Text
        font="h5Regular"
        color="textSecondary"
        mb="6.7rem"
        align="center"
        fontFamily="Roboto"
      >
        {data?.subtitle}
      </Text>
      <QueryAccount>
        {({ account }) => {
          return account === '0' ? (
            <Text
              font="h5Bold"
              color="#e7303c"
              align="center"
              fontFamily="Roboto"
            >
              Please connect Metamask!
            </Text>
          ) : (
            <Flex className="search-box">
              <Input
                value={inputVal}
                placeholder="john.bnb"
                onChange={onChange}
              />
              <Button
                toggleBackground
                height="7.2rem"
                disabled={isLoading}
                onClick={() => onSearch(account)}
              >
                {!isLoading && <SearchIcon fill={isDark ? 'black' : 'white'} />}
                <Text font="" color={isDark ? 'black' : 'white'}>
                  {data?.button?.title}.BNB
                </Text>
                {isLoading && (
                  <div style={{ marginLeft: 10 }}>
                    <Loader />
                  </div>
                )}
              </Button>
            </Flex>
          )
        }}
      </QueryAccount>
    </Wrapper>
  )
}

export default CallToAction

const Input = styled.input`
  padding: 2rem;
  border: 1px solid black;
  height: 7.2rem;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 70rem;
  color: #000;

  ::placeholder {
    color: #838383;
    font-size: 2rem;
    font-weight: 500;
  }
`
